import { trackCatalogEvent } from '~/modules/catalogEventTracking.js'

export const PERSONAL_PROJECT_ANALYTICS_EVENTS = Object.freeze([
  'personal_project_created',
  'personal_project_opened',
  'personal_project_archived',
  'personal_project_item_added',
  'personal_project_variant_added',
  'personal_project_item_removed',
  'personal_project_add_modal_opened',
  'workspace_upgrade_intent_from_personal_project'
])

const SAFE_PROPERTY_KEYS = Object.freeze(['project_id', 'project_track_id', 'track_id', 'track_variant_id', 'surface'])
const SURFACE_VALUES = Object.freeze(['catalog_track', 'catalog_variant', 'favorites', 'personal_project', 'personal_project_detail'])

export function personalProjectsEnabled(documentRef = document) {
  const value = documentRef?.body?.getAttribute('data-personal-projects-enabled')
  return value !== 'false'
}

export function trackPersonalProjectEvent(eventName, properties = {}, { documentRef = document } = {}) {
  if (!PERSONAL_PROJECT_ANALYTICS_EVENTS.includes(eventName) || !personalProjectsEnabled(documentRef) || !trackingConsentGranted(documentRef)) {
    return false
  }

  try {
    return trackCatalogEvent(eventName, normalizeProperties(properties))
  } catch (_error) {
    return false
  }
}

export function trackingConsentGranted(documentRef = document) {
  if (!documentRef || typeof documentRef.cookie !== 'string') {
    return false
  }

  const rawCookie = documentRef.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith('cookie_consent_level='))
    ?.slice('cookie_consent_level='.length)

  if (!rawCookie) {
    return false
  }

  try {
    const consentLevels = JSON.parse(decodeURIComponent(rawCookie.replace(/\+/g, ' ')))
    return consentLevels && consentLevels.tracking === true
  } catch (_error) {
    return false
  }
}

export function bindPersonalProjectUpgradeIntentTracking(documentRef = document) {
  if (!documentRef || documentRef.__personalProjectUpgradeIntentTrackingBound) {
    return
  }

  documentRef.__personalProjectUpgradeIntentTrackingBound = true
  documentRef.addEventListener('click', (event) => {
    const trigger = event.target?.closest?.('[data-personal-project-upgrade-intent]')
    if (!trigger) {
      return
    }

    trackPersonalProjectEvent('workspace_upgrade_intent_from_personal_project', {
      project_id: trigger.dataset.personalProjectId,
      surface: 'personal_project'
    })
  })
}

function normalizeProperties(properties) {
  const source = properties && typeof properties === 'object' ? properties : {}
  const normalized = {}

  SAFE_PROPERTY_KEYS.forEach((key) => {
    const value = source[key]
    if (value === undefined || value === null || value === '') {
      return
    }

    if (key === 'surface') {
      const surface = String(value).trim()
      if (SURFACE_VALUES.includes(surface)) {
        normalized[key] = surface
      }
      return
    }

    const id = Number(value)
    if (Number.isInteger(id) && id > 0) {
      normalized[key] = id
    }
  })

  return normalized
}
